import React, { useState, useEffect } from 'react';
import "../result/result.css";
import AlertMessage from "../../AlertMessage";

function IcseResult() {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [subjectSequence, setSubjectSequence] = useState([]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [serialNoData, setSerialNoData] = useState({});
  

  const udiseNumber = localStorage.getItem("udiseNumber");
 
  const [examNames, setExamNames] = useState([
    "Unit Test I",
    "Unit Test II",
    "Semester First ",
    "Unit Test III",
    "Unit Test IV",
    "Semester Second ",
  ]);

  const examNameTranslations = {
    "Unit Test I" : "घटक चाचणी-1",
    "Unit Test II" : "घटक चाचणी-2",
    "Semester First ": "प्रथम सत्र",
    "Unit Test III" : "घटक चाचणी-3",
    "Unit Test IV" : "घटक चाचणी-4",
    "Semester Second ": "द्वितीय सत्र",
  };


  // Reset divisions when class changes
  useEffect(() => {
    if (classValue) {
      const divisionsForClass = studentData
        .filter(student => student.currentClass === classValue)
        .map(student => student.division)
        .filter((value, index, self) => value && self.indexOf(value) === index);
      setDivisions(divisionsForClass);
    } else {
      setDivisions([]);
    }
  }, [classValue, studentData]);

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (academicYear && classValue && division) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue, division]);

  const fetchSubjectSequence = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`
      );

      if (!response.ok) {
        throw new Error('Failed to fetch subject sequence');
      }
      const data = await response.json();

      // Check if data is valid before proceeding
      if (data && typeof data === 'object') {
        const orderedSubjects = Object.keys(data)
          .filter(key => data[key]) // Filter out null or empty subjects
          .sort((a, b) => parseInt(a) - parseInt(b))
          .map((key) => data[key]);
        setSubjectSequence(orderedSubjects);
      } else {
        console.error('Invalid data format for subject sequence:', data);
        setSubjectSequence([]); // Reset to empty if data is invalid
      }
    } catch (error) {
      console.error('Error fetching subject sequence:', error);
      setSubjectSequence([]); // Reset to empty on error
    }
  };


  const [schoolData, setSchoolData] = useState(null); 
  
   // Fetch school data from IndexedDB
    const fetchSchoolData = async (db) => {
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(SCHOOL_STORE, "readonly");
        const store = transaction.objectStore(SCHOOL_STORE);
        const request = store.get(udiseNumber);
        
        request.onsuccess = (event) => {
          const data = event.target.result;
          setSchoolData(data);
          resolve(data);
        };
        
        request.onerror = (event) => {
          console.error("Error fetching school data from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    };


  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
    const SCHOOL_STORE = 'schoolData';


  useEffect(() => {
    const openDB = () => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        
        request.onerror = (event) => {
          console.error("IndexedDB error:", event.target.error);
          reject(event.target.error);
        };
        
        request.onsuccess = (event) => {
          const db = event.target.result;
          resolve(db);
        };
        
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          
          // Create object stores if they don't exist
          if (!db.objectStoreNames.contains(STUDENT_STORE)) {
            db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
          }

           if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
              db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
            }
        };
      });
    };

    const fetchStudentData = async (db) => {
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(STUDENT_STORE, "readonly");
        const store = transaction.objectStore(STUDENT_STORE);
        const request = store.getAll();
        
        request.onsuccess = (event) => {
          const students = event.target.result;
          setStudentData(students);
          
          // Organize students by class and division for serialNoData
          const classesAndDivisions = {};
          students.forEach((student) => {
            if (student && student.currentClass) {
              if (!classesAndDivisions[student.currentClass]) {
                classesAndDivisions[student.currentClass] = {};
              }
              
              const division = student.division || "";
              if (!classesAndDivisions[student.currentClass][division]) {
                classesAndDivisions[student.currentClass][division] = [];
              }
              
              // Use the ID as the serial number equivalent
              classesAndDivisions[student.currentClass][division].push(student.id);
            }
          });

          setSerialNoData(classesAndDivisions);
          setClasses(Object.keys(classesAndDivisions));
          resolve(students);
        };
        
        request.onerror = (event) => {
          console.error("Error fetching student data from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    };

    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
                  await fetchSchoolData(db);

      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear, division]); // Added division as dependency


  const fetchMarksForSelectedSubject = async () => {
    try {
      // Filter students by both class and division
       const filteredStudents = studentData.filter(
      (student) => student.currentClass === classValue && 
                  (division === "" || student.division === division) &&
                  student.isActive !== false // Add this line to filter active students
    );
      
      setSelectedStudents(filteredStudents);
      
      const marksDataPromises = filteredStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.id,
          academicYear,
          selectedExamName
        );
        return { srNo: student.id, marks: studentMarks };
      });
  
      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});
  
      setMarksData(marksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };
  
  const fetchMarksData = async (srNo, academicYear, examName) => {
    try {
      const student = studentData.find((student) => student.id === srNo);
      if (student && student.icseResult && student.icseResult[academicYear] && student.icseResult[academicYear][examName]) {
        const marks = student.icseResult[academicYear][examName];
        const subjectMarks = {};
        Object.keys(marks).forEach((subject) => {
          if (subject !== 'remark') {
            subjectMarks[subject] = marks[subject];
          }
        });
        return subjectMarks;
      } else {
        return {};
      }
    } catch (error) {
      console.error('Error fetching marks data:', error);
      return {};
    }
  };

  const transformDataForGradeTable = () => {
    if (!selectedStudents.length || !marksData) return [];
    
    const data = selectedStudents.map(student => {
      const grades = subjectSequence.map(subject => {
        const studentMarks = marksData[student.id] || {};
        console.log("studentMarks",studentMarks);
        
        // const totalMarks = (studentMarks[subject]?.obtainMarks || 0) + (studentMarks[subject]?.outOf || 0);

        const obtainedMarks = (studentMarks[subject]?.obtainMarks || 0) + (studentMarks[subject]?.firstSemesterObtainMarks || 0);
        const maxMarks = (studentMarks[subject]?.outOf || 0) + (studentMarks[subject]?.firstSemesterOutOf || 0);
        
        // Calculate percentage
        const percentage = maxMarks > 0 ? (obtainedMarks / maxMarks) * 100 : 0;

        
        return calculateGrade(percentage); // Calculate grade based on total marks
      });
    
      return {
        rollNo: student.rollNo,
        division: student.division || "",
        name: `${student.stdName} ${student.stdFather} ${student.stdSurname}`,
        grades,
      };
    });
    
    // Sort first by division, then by roll number
    return data.sort((a, b) => {
      // First sort by division
      if (a.division !== b.division) {
        return a.division.localeCompare(b.division);
      }
      // Then by roll number
      return a.rollNo - b.rollNo;
    });
  };

  const calculateGrade = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Absent';
  };

  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);
  const handleClassChange = (e) => {
    setClassValue(e.target.value);
    setDivision(""); // Reset division when class changes
  };
  const handleExamNameChange = (e) => {
    setSelectedExamName(e.target.value);
  };

  const gradeTableData = transformDataForGradeTable();


  const handlePrint = () => {
    const tableElement = document.getElementById("printableTable");
    if (tableElement) {
      const tableContent = tableElement.outerHTML;
  
      const schoolName = schoolData?.schoolName || "";
      const schoolLogo = schoolData?.schoolLogo || ""; // Placeholder if no logo is available
  
      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
  
      // Include your styles here
      printWindow.document.write(`
        <style>
          @page {
            size: A4 Landscape; 
            margin: 3mm;
          }
          table {
              width: 100%;
              border-collapse: collapse;
              margin:auto;
          }
          th, td {
              border: 1px solid #ccc;
              padding: 5px;
              text-align: center;
          }
          thead th {
              background-color: #f4f4f4;
              font-weight: normal; /* Removes bold styling */
          }
          tbody td {
              text-align: center;
              font-weight: normal; /* Removes bold styling */
          }
          .table th, .table td {
              border: 1px solid #ccc;
              padding: 5px;
              text-align: center;
             
          }
          .table thead th {
              background-color: #f4f4f4;
          }
          .table tbody td {
              text-align: center;
          }
          .school-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 20px;
            padding: 10px;
            border: 1px solid #ccc; /* Add border to the header */
          }
          .school-header img {
            max-height: 70px; /* Adjust as needed */
            margin-right: 15px; /* Spacing between logo and school name */
          }
          .school-header h1 {
            font-size: 24px; /* Increased font size for school name */
            margin: 0;
            text-align: left; /* Align text to the left */
            flex: 1; /* Take up remaining space */
            text-overflow: ellipsis; /* Add ellipsis if text overflows */
            white-space: nowrap; /* Prevent text from wrapping to next line */
          }
          .school-header h1.multi-line {
            text-align: center; /* Center text if it wraps to next line */
            white-space: normal; /* Allow text to wrap to next line */
          }
          .school-header-container {
            margin-bottom: 20px;
          }
          .division-header {
            background-color: #f0f0f0;
            font-weight: bold;
            text-align: left;
            padding: 10px;
            border: 1px solid #ccc;
            margin-top: 20px;
          }
        </style>
      `);
      printWindow.document.write("</head><body>");
      
      // Add school header with increased text size and logo to the left
      const img = printWindow.document.createElement("img");
      img.src = schoolLogo;
      img.alt = "School Logo";

      img.onload = function() {
        printWindow.document.write(`
          <div class="school-header-container">
            <div class="school-header">
              <img src="${schoolLogo}" alt="School Logo">
              <h1 class="${schoolName.length > 30 ? 'multi-line' : ''}">${schoolName}</h1>
              <p>Class: ${classValue}</p>
            </div>
          </div>
        `);

        // Add the table content
        printWindow.document.write(tableContent);

        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
      };

      img.onerror = function() {
        // If the logo fails to load, proceed without the logo
        printWindow.document.write(`
          <div class="school-header-container">
            <div class="school-header">
              <h1 class="${schoolName.length > 30 ? 'multi-line' : ''}">${schoolName}</h1>
              <p>Class: ${classValue} ${division ? `Div: ${division}` : ''}</p>
            </div>
          </div>
        `);

        // Add the table content
        printWindow.document.write(tableContent);

        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
      };
    } else {
      console.error("Table element with ID 'printableTable' not found.");
    }
  };


  // Group students by division for the table display
  const groupStudentsByDivision = () => {
    if (!gradeTableData.length) return {};
    
    const grouped = {};
    gradeTableData.forEach(student => {
      if (!grouped[student.division]) {
        grouped[student.division] = [];
      }
      grouped[student.division].push(student);
    });
    
    return grouped;
  };

  const groupedStudents = groupStudentsByDivision();

  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className='main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)', textAlign: 'center' }}>
          {language === "English" ? "ICSE Gradewise Result" : " ICSE श्रेणीनिहाय निकाल"}
        </h3>
        <table className="table table-striped table-bordered" style={{width:'60%'}}>
          <tbody>
            <tr>
              <th>{language === "English" ? "Year " : "शैक्षणिक वर्ष  "}</th>
              <td>
                <select
                  id="academicYear"
                  value={academicYear}
                  onChange={handleAcademicYearChange}
                  className="form-control custom-select"
                >
                  <option>{language === "English" ? "Select Year " : "वर्ष निवडा "}</option>
                  <option value="2023-2024">2023-2024</option>
                  <option value="2024-2025" selected>2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Class " : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division " : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "All Divisions" : "सर्व तुकडी"}</option>
                  {divisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षा"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Exam" : "परीक्षा निवडा"}</option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{textAlign:'right'}}>
          <button onClick={handlePrint}>Print</button>
        </div>
        {gradeTableData.length > 0 && (
          <div className="mt-4" style={{margin:'auto',marginBottom:'30px', padding:'30px 10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',width:'100%' , overflowX:'scroll'}}>
            <div id='printableTable'>
              <h4 style={{textAlign:'center'}}>{selectedExamName} Result</h4>
              
              {/* If specific division is selected, show just one table */}
              {division ? (
                <table className="table table-striped table-bordered" style={{width:'100%'}}>
                  <thead>
                    <tr>
                      <th>{language === "English" ? "Roll No" : "हजेरी क्र"}</th>
                      <th>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                      {subjectSequence.map((subject, index) => (
                        <th key={index}>{subject}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {gradeTableData.map((student, index) => (
                      <tr key={index}>
                        <td>{student.rollNo}</td>
                        <td>{student.name}</td>
                        {student.grades.map((grade, idx) => (
                          <td key={idx}>{grade}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                /* If all divisions are selected, group students by division */
                Object.keys(groupedStudents)
                .sort()
                
                .map(div => (
                  <div key={div}>
                    <div className="division-header">
                      {language === "English" ? `Division: ${div}` : `तुकडी: ${div}`}
                    </div>
                    <table className="table table-striped table-bordered" style={{width:'100%'}}>
                      <thead>
                        <tr>
                          <th>{language === "English" ? "Roll No" : "हजेरी क्र"}</th>
                          <th>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                          {subjectSequence.map((subject, index) => (
                            <th key={index}>{subject}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {groupedStudents[div].map((student, index) => (
                          <tr key={index}>
                            <td>{student.rollNo}</td>
                            <td>{student.name}</td>
                            {student.grades.map((grade, idx) => (
                              <td key={idx}>{grade}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default IcseResult;